import { IScheduleWeekdayDaypartRecord } from 'src/components/timeRow';
import { IDaypartsWithDefaultAssembly } from 'src/hooks/useGetDefaultAssemblyOfDayparts';
import {
  IScheduleDaypart,
  IScheduleDaypartOverride,
  IWeekdayDaypart,
} from 'src/interfaces';

export const getGroupDaypartActiveStatus = (
  daypartsWithDefaultAssemblyGroup: IDaypartsWithDefaultAssembly[] = [],
  groupScheduleWeekdayDaypartsRecord?: IScheduleWeekdayDaypartRecord[],
  rbStoreIntegration?: boolean,
) => {
  const groupDaypartsActiveStatus = daypartsWithDefaultAssemblyGroup.reduce(
    (acc, daypart) => {
      const isActive = !rbStoreIntegration
        ? !!groupScheduleWeekdayDaypartsRecord
            ?.filter((weekday) => weekday.daypart.id === daypart.id)
            .some((item) => item.start_time)
        : !!daypart?.defaultAssembly;

      acc[daypart.id] = isActive;

      return acc;
    },
    {} as Record<number, boolean>,
  );

  return groupDaypartsActiveStatus;
};

export const mapScheduleWeekdayDaypartsRecord = (
  locationGroupId: number,
  locGroupScheduleDayparts: IScheduleDaypart[],
  locationDaypartsOverrides: IScheduleDaypartOverride[] = [],
  weekdayDaypartOptions: IWeekdayDaypart[] = [],
) => {
  const daypartWeekdayTimes = locGroupScheduleDayparts.map((groupDaypart) => {
    const findOverrideDaypart = locationDaypartsOverrides.find(
      (schedule) => schedule.schedule_daypart_id === groupDaypart.id,
    );
    const weekdayDaypart = weekdayDaypartOptions.find(
      (weekdayDaypart) => weekdayDaypart.id === groupDaypart.weekday_daypart_id,
    );
    const startTime = findOverrideDaypart
      ? findOverrideDaypart.start_time
      : groupDaypart.start_time;

    return {
      id: groupDaypart.id,
      location_group_id: locationGroupId,
      weekday_daypart_id: groupDaypart?.weekday_daypart_id,
      scheduleDaypartOverrideId: findOverrideDaypart
        ? findOverrideDaypart.id
        : null,
      start_time: startTime,
      weekday: weekdayDaypart?.weekday,
      daypart: weekdayDaypart?.daypart,
      isOverride: !!findOverrideDaypart,
    } as unknown as IScheduleWeekdayDaypartRecord;
  });

  return daypartWeekdayTimes;
};

export const checkDaypartsStatus = (data: IScheduleWeekdayDaypartRecord[]) => {
  const result = new Map<number, boolean>();

  // Group records by daypart.id
  const grouped = data.reduce((acc, record) => {
    const daypartId = record.daypart?.id;
    if (!daypartId) return acc;

    if (!acc[daypartId]) acc[daypartId] = [];

    acc[daypartId].push(record);

    return acc;
  }, {} as Record<number, IScheduleWeekdayDaypartRecord[]>);

  Object.entries(grouped).forEach(([daypartId, records]) => {
    const isActive = records.some((rec) => !!rec.start_time);
    result.set(Number(daypartId), isActive);
  });

  return result;
};
